// extracted by extract-css-chunks-webpack-plugin
module.exports = {"googleAdvertContainer":"googleAdvertContainer_P21lh"};